<script>
    // -- IMPORTS

	import NewBlock from './../../../../../ADMIN/src/lib/component/element/NewBlock.svelte';
    import Modal from "../../../../../ADMIN/src/lib/component/element/Modal.svelte";
    import { enabledAdminView } from '$src/lib/store/adminStore';

    // -- VARIABLES

    /** @type {{pageId?: string, isManager?: boolean}} */
    let { pageId = '', isManager = false } = $props();

    let blockData = {
        id : '',
        slug : 'new',
        typeSlug : 'text-and-media',
        number : 0,
        isActive : true,
        title : '',
        text : '',
        textArray: [],
        subTitle : '',
        description : '',
        mediaPath : '',
        mediaPathArray : [],
        imageAlt : '',
        imagFit : '',
        imageHorizontalPosition : '',
        imageVerticalPosition : '',
        imageSide: 'right',
        imageLegend: ''
    };

    let blockManagerData = {
        name: '',
        mediaPath : null,
        position: '',
        linkedinLink: '',
        instagramLink: '',
        emailAddress: '',
        imageSide: 'left',
        mediaPathArray : [],
    }
    
    let isAddBlockModalOpen = $state(false);

    // -- FUNCTIONS

    function handleOpenAddBlockModal(
        )
    {
        isAddBlockModalOpen = true;
    }

    // ~~

    function onBlockCreated(
        )
    {
        isAddBlockModalOpen = false;
        window.location.reload();
    }
</script>

<style lang="stylus">
   // -- IMPORTS

    @import '../../../constant.styl';
    @import '../../../mixin.styl';

    // -- CLASSES

    .divider-container
    {
        position: relative;

        width: 100%;
        margin: 1.25rem 0 2.5rem 0;
        margin-bottom: 5rem;


        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        background-color: transparent;

        cursor: pointer;

        &:after
        {
            position: absolute;
            content: '';
            z-index: 0;

            border-radius: 4px;
            
            width: 100%;
            height: 4px;

            background-color: #2A2A2A;

            transition: all .3s ease-in-out;
        }

        transition: all .3s ease-in-out;
    }

    .divider-container:hover
    {
        padding-bottom: 0.75rem;

        &:after
        {
            height: 5rem;
        }
    }

    .add-block-container
    {
        z-index: 2;

        border-radius: 4px;
        padding: .5rem;
        background-color: #2A2A2A;

        display: flex;
        align-items: center;
        justify-content: center;

        transition: height .5s ease-in-out;
    }

    .add-new-label
    {
        opacity: 0;
        z-index: 2;

        max-height: 0;
        max-width: 24rem;

        color: lightGreyColor;
        font-size: 1rem;
        font-weight: 600;

        transition: opacity 0.3s ease-in-out;
    }

    .divider-container:hover .add-new-label
    {
        opacity: 1;

        max-height: 2rem;
        max-width: 24rem;
    }
</style>

<Modal
    bind:showModal={ isAddBlockModalOpen }
    modalConfirmButtonLabel="Save"
    modalType=""
    hasFooterButtons={ false }
    modalTitle="Add Block"
>
    <NewBlock
        pageId={ pageId }
        blockData={ isManager ? blockManagerData : blockData }
        isManager={ isManager }
        onBlockCreated={ onBlockCreated }
    />
</Modal>

{#if $enabledAdminView}
    <button 
        class="divider-container" 
        onclick={handleOpenAddBlockModal}
    >
        <div class="add-block-container">
            <div class="light-grey-plus-icon size-150">
            </div>
        </div>

        <p class="add-new-label">ADD NEW BLOCK</p>
    </button>
{/if}